import {
    CLUSTER_DATA,
    CLUSTER_DATA_TEMPLATE,
    CONFIG_CONTENT,
    CONNECTION_STATUS,
    DATA_LOADING,
    PROGRESS_LOADING,
    GET_VERSION,
    JOB_LIST,
    LOG_FILES,
    LOG_SNIPPET,
    REDIRECT,
    SELECT_SCHEMA,
    SELECT_UI_SCHEMA,
    SET_OPERATOR,
    SET_LOG_LEVEL,
    IS_VALID_KEY,
    API_KEY,
    COMP_PERM,
    USER_ROLES,
    ROLES_DATA,
    RESOURCES_DATA,
    COMP_PERM_STRING,
    KEY_GENERATE,
    SERVER_STATE,
    IS_CONFIG_USER,
    USER_ROLE_LIST,
    APP_CONFIG_DATA,
    USER_DATA,
    GET_API_KEY,
    GET_ALL_USER,
    GET_ALL_SYS_CONFIG,
    GET_LIVE_JOB_LIST,
    GET_DP_RIGS_LIST,
    GET_DP_DP_LIST,
    GET_DP_BUNIT_LIST,
    GET_FINISH_JOB_LIST,
    GET_LIVE_JOB_TOTAL_RECORDS,
    GET_FINISH_JOB_TOTAL_RECORDS,
    GET_DATA_QUALITY_CHART_DATA,
    GET_DATA_QUALITY_TIME,
    GET_ALL_USER_TOTAL_RECORD,
    CHANGE_PASSWORD,
    GET_ALL_ROLES_DATA_RECORD,
    VUSER_ROLE_LIST_TOTALRECORDS,
    GET_ALL_DATA_PROVIDER_TOTAL_RECORD,
    APP_CONFIG_DATA_TOTALRECORDS,
    DOWNLOAD_JOB,
    GET_ALL_LICENSE_DATA,
    GET_ALL_LICENSE_DATA_RECORD,
    GET_ALL_ROLES,
    GET_NODE_INFO_LIST,
    GET_NODE_INFO_DATA,
    GET_TOTAL_RECORD_NODE_INFO,
    IS_SUCCESS
} from "../constants/action-types";
import pyData from "../../Assets/DefaultData/py_data.json";
import pySchema from "./../../Assets/Schemas/py_schema.json";
import pyUiSchema from "./../../Assets/UiSchemas/pyUiSchema.json";
import { useDispatch } from "react-redux";
import { loadingOff } from "../utils";

const initialState = {
    isValidKey: sessionStorage.getItem("isValidKey") !== undefined && sessionStorage.getItem("isValidKey") !== null ? JSON.parse(sessionStorage.getItem("isValidKey")) : false,
    connectionStatus: false,
    redirect: false,
    jobList: [],
    clusterData: {},
    clusterDataTemplate: {},
    logSnippet: "",
    config: pyData,
    schema: pySchema,
    uiSchema: pyUiSchema,
    operator: "py",
    logFiles: ['PatternSon814', 'CRUD Operation', '123PatterSon', 'Manage Rigs', 'Channels Rig Config'],
    loading: false,
    progressLoading: false,
    version: "",
    notifications: [],
    waitedJobs: [],
    filePath: "",
    logLevel: "",
    apiKey: "",
    groups: {},
    userRoles: {},
    rolesData: [],
    userRolesData: {},
    resourcesData: [],
    keyGenerate: '',
    serverStats: '',
    isConfigUser: sessionStorage.getItem("isConfigUser") !== undefined && sessionStorage.getItem("isConfigUser") !== null ? JSON.parse(sessionStorage.getItem("isConfigUser")) : false,
    cmpntGroup: {},
    roleList: [],
    vuserTotalRecord: 0,
    appConfigData: [],
    appConfigDataTotalRecord: 0,
    userData: {},
    userApiKey: '',
    allUserdata: [],
    userTableCount: [],
    roleTableCount: 0,
    allRole: [],
    getSysConfigData: [],
    getSysConfigDataTotalRecord: 0,
    liveJobList: [],
    liveJobListTotalRecords: 0,
    dataProvider: [],
    rigsData: [],
    bUnitData: [],
    finishList: [],
    finishListTotalRecords: 0,
    dataqualityChartData: {},
    dataQulityChartTime: [],
    changePassword: [],
    jobDownload: [],
    getAllLiceseDataRecord: [],
    getAllLiceseData: [],
    nodeInfo: [],
    allNodeInfo: [],
    nodeInfoTableCount: 0,
    isSuccess: false,
    apiUrl: localStorage.getItem("server-list") ? JSON.parse(localStorage.getItem("server-list")).filter((server) => server.selected).length !== 0
        ? JSON.parse(localStorage.getItem("server-list")).filter(
            (server) => server.selected
        )[0]
        : { name: "Default", address: `${window.location.protocol}//${window.location.host}` } : { name: "Default", address: `${window.location.protocol}//${window.location.host}` },
    bcApiUrl: localStorage.getItem("bc-server-list") ? JSON.parse(localStorage.getItem("bc-server-list")).filter((server) => server.selected).length !== 0
        ? JSON.parse(localStorage.getItem("bc-server-list")).filter(
            (server) => server.selected
        )[0]
        : { name: "Default", address: `${window.location.protocol}//${window.location.host}` } : { name: "Default", address: `${window.location.protocol}//${window.location.host}` },

};

const data = (state = initialState, action) => {
    switch (action.type) {
        case IS_VALID_KEY:
            sessionStorage.setItem("isValidKey", action.payload)
            return {
                ...state,
                isValidKey: action.payload
            }
        case CLUSTER_DATA_TEMPLATE:
            return {
                ...state,
                clusterDataTemplate: action.payload,
            };
        case SET_LOG_LEVEL:
            return {
                ...state,
                logLevel: action.payload,
            };
        case CONNECTION_STATUS:
            return {
                ...state,
                connectionStatus: action.payload,
            };
        case JOB_LIST:
            return {
                ...state,
                jobList: action.payload,
            };
        case LOG_SNIPPET:
            return {
                ...state,
                logSnippet: action.payload,
            };
        case CONFIG_CONTENT:
            return {
                ...state,
                config: action.payload,
            };
        case SELECT_SCHEMA:
            return {
                ...state,
                schema: action.payload,
            };
        case SELECT_UI_SCHEMA:
            return {
                ...state,
                uiSchema: action.payload,
            };
        case CLUSTER_DATA:
            return {
                ...state,
                clusterData: action.payload,
            };
        case LOG_FILES:
            return {
                ...state,
                logFiles: action.payload,
            };
        case DATA_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case PROGRESS_LOADING:
            return {
                ...state,
                progressLoading: action.payload,
            };
        case GET_VERSION:
            return {
                ...state,
                version: action.payload,
            };
        case SET_OPERATOR:
            return {
                ...state,
                operator: action.payload,
            };
        case REDIRECT:
            return {
                ...state,
                redirect: action.payload,
            };
        case API_KEY:
            return {
                ...state,
                apiKey: action.payload,
            };
        case COMP_PERM:
            return {
                ...state,
                cmpntGroup: action.payload
            };
        case USER_ROLES:
            return {
                ...state,
                userRoles: action.payload,
            };
        case ROLES_DATA:
            return {
                ...state,
                rolesData: action.payload,
            };
        case GET_ALL_ROLES_DATA_RECORD:
            return {
                ...state,
                roleTableCount: action.payload,
            };
        case GET_ALL_ROLES:
            return {
                ...state,
                allRole: action.payload,
            };
        case RESOURCES_DATA:
            return {
                ...state,
                resourcesData: action.payload,
            };
        case COMP_PERM_STRING:
            return {
                ...state,
                userRolesData: action.payload,
            };
        case KEY_GENERATE:
            return {
                ...state,
                keyGenerate: action.payload,
            };
        case SERVER_STATE:
            return {
                ...state,
                serverStats: action.payload,
            };
        case IS_CONFIG_USER:
            sessionStorage.setItem("isConfigUser", action.payload);
            return {
                ...state,
                isConfigUser: action.payload,
            };
        case USER_ROLE_LIST:
            return {
                ...state,
                roleList: action.payload,
            };
        case VUSER_ROLE_LIST_TOTALRECORDS:
            return {
                ...state,
                vuserTotalRecord: action.payload,
            };
        case APP_CONFIG_DATA:
            return {
                ...state,
                appConfigData: action.payload,
            };
        case APP_CONFIG_DATA_TOTALRECORDS:
            return {
                ...state,
                appConfigDataTotalRecord: action.payload,
            };
        case USER_DATA:
            return {
                ...state,
                userData: action.payload,
            };
        case GET_API_KEY:
            return {
                ...state,
                userApiKey: action.payload,
            };
        case GET_ALL_USER:
            return {
                ...state,
                allUserdata: action.payload,
            };
        case GET_ALL_USER_TOTAL_RECORD:
            return {
                ...state,
                userTableCount: action.payload,
            };
        case GET_ALL_SYS_CONFIG:
            return {
                ...state,
                getSysConfigData: action.payload,
            };
        case GET_ALL_DATA_PROVIDER_TOTAL_RECORD:
            return {
                ...state,
                getSysConfigDataTotalRecord: action.payload,
            };
        case GET_LIVE_JOB_LIST:
            return {
                ...state,
                liveJobList: action.payload
            };
        case GET_LIVE_JOB_TOTAL_RECORDS:
            return {
                ...state,
                liveJobListTotalRecords: action.payload
            };
        case GET_DP_RIGS_LIST:
            return {
                ...state,
                rigsData: action.payload
            };
        case GET_DP_DP_LIST:
            return {
                ...state,
                dataProvider: action.payload
            };
        case GET_DP_BUNIT_LIST:
            return {
                ...state,
                bUnitData: action.payload
            };
        case GET_NODE_INFO_LIST:
            return {
                ...state,
                nodeInfo: action.payload
            };
        case GET_FINISH_JOB_LIST:
            return {
                ...state,
                finishList: action.payload
            };
        case GET_FINISH_JOB_TOTAL_RECORDS:
            return {
                ...state,
                finishListTotalRecords: action.payload
            };
        case GET_DATA_QUALITY_CHART_DATA:
            return {
                ...state,
                dataqualityChartData: action.payload
            };
        case GET_DATA_QUALITY_TIME:
            return {
                ...state,
                dataQulityChartTime: action.payload
            };
        case CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: action.payload
            };
        case DOWNLOAD_JOB:
            return {
                ...state,
                jobDownload: action.payload
            };
        case GET_ALL_LICENSE_DATA:
            return {
                ...state,
                getAllLiceseData: action.payload
            };
        case GET_ALL_LICENSE_DATA_RECORD:
            return {
                ...state,
                getAllLiceseDataRecord: action.payload
            };
        case GET_NODE_INFO_DATA:
            return {
                ...state,
                allNodeInfo: action.payload
            };
        case GET_TOTAL_RECORD_NODE_INFO:
            return {
                ...state,
                nodeInfoTableCount: action.payload
            };
        case IS_SUCCESS:
            return {
                ...state,
                isSuccess: action.payload
            };


        default:
            return state;
    }
};

export default data;